import * as ActionTypes from "constants/ActionTypes";

export function setForceChapterCover(value) {
  return {
    type: ActionTypes.SET_FORCE_CHAPTER_COVER,
    value,
  };
}
